import { memo, useState } from 'react';
import { Checkbox, message } from 'antd';
import { useLockFn } from 'ahooks';
import { environment } from '@gaodun.com/gtools';
import { createProductOrdered, getPayQrcode } from '@/apis';

interface IProps {
    ininInfo?: { projectId: number; lucaId: number };
    productId?: number;
    productAmount?: number;
}

const PlaceOrder = ({ ininInfo, productId = 0, productAmount = 0 }: IProps) => {
    const [isChecked, setChecked] = useState(false);

    const handlePayMoney = useLockFn(async () => {
        if (!isChecked) {
            return message.warning('请同意用户权益服务协议');
        }
        // 创建用户订单
        const res = await createProductOrdered({
            // studentId: stringify;
            orderSource: 1000442,
            clueParameters: '{"lucaOrder":true}',
            productId,
            appId: 'wx4f1fcbd78ee2b420',
            orderPay: {
                payChannelType: 'cashier',
                payChannel: 'Wechat',
                payType: '148',
                payBackUrl: `https://${environment.getEnv()}muses.gaodun.com/ape/luca/pay/result?pid=${ininInfo!.projectId}`,
            },
            productType: 'serviceProduct',
        });
        if (res.status === 0) {
            // 获取收银台地址
            const payRes = await getPayQrcode({
                orderNo: res.result.orderNo,
                returnUrl: `https://${environment.getEnv()}muses.gaodun.com/ape/luca/pay/result?pid=${ininInfo!.projectId}`,
            });
            if (payRes.status === 0) {
                window.open(payRes.result.payUrl);
            }
        }
    });

    return (
        <div className="rights-btn-box">
            <div>
                <Checkbox className="rights-checkbox" onClick={() => setChecked(!isChecked)} checked={isChecked} />
                <span style={{ margin: '0 4px 0 6px', color: '#00000040' }}>支付及同意</span>
                <span onClick={() => window.open(`https://${environment.getEnv()}luca.gaodun.com/user/rights/tips`)}>
                    《用户权益服务协议》
                </span>
            </div>
            <div onClick={handlePayMoney}>确认协议并支付¥{productAmount}元</div>
        </div>
    );
};

export default memo(PlaceOrder);
